import EmptyStateNothingFound from "@/components/empty-state/EmptyStateNothingFound.tsx";
import { useTitle } from "@/hooks/use-title.hook.ts";
import { findSettingsGroup } from "@/pages/settings/index/settings.types.ts";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { Card, Page, Stack } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function SettingsGroupPage({ groupKey: groupKeyProp }: { groupKey?: string } = {}) {
  const { t } = useTranslation();
  const params = useParams<{ groupKey: string }>();
  const groupKey = groupKeyProp ?? params.groupKey;
  const { data: employee } = useEmployeeMe();

  const group = useMemo(() => {
    if (!employee || !groupKey) return undefined;
    return findSettingsGroup(employee, groupKey);
  }, [employee, groupKey]);

  useTitle(group?.title ?? t("common:settings"));

  return (
    <Page>
      <Page.Header title={group?.title ?? t("common:settings")} showBack navigateTo="/settings" />

      <Page.Content>
        <Stack className={"py-10 px-16 gap-6"}>
          {!group ? (
            <EmptyStateNothingFound />
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4">
              {group.items.map((item) => (
                <Card
                  key={item.to}
                  icon={item.icon}
                  header={item.title}
                  caption={item.description}
                  to={item.to}
                />
              ))}
            </div>
          )}
        </Stack>
      </Page.Content>
    </Page>
  );
}
